export const isRecord = (
  input: unknown,
): input is Record<PropertyKey, unknown> =>
  typeof input === 'object' && input !== null;

export const hasKey = <K extends PropertyKey>(
  input: unknown,
  key: K,
): input is Record<K, unknown> => isRecord(input) && key in input;

export const hasKeyValue = <K extends PropertyKey, V>(
  input: unknown,
  key: K,
  value: V,
): input is Record<K, V> => isRecord(input) && input[key] === value;
